import { useReducer, useMemo, Dispatch } from 'react';

import { SubscriptionSummary, MixSummary } from 'ggApp/types/graphql';

import useAction from '../../hooks/useAction';

import reducer, { defaultState, SummaryState } from './reducer';
import {
    setSubscriptionSummary as setSubscriptionSummaryAction,
    setMixSummary as setMixSummaryAction,
    Action,
} from './actions';

function useActions(dispatch: Dispatch<Action>): SubscriptionSummaryActions {
    const setSubscriptionSummary = useAction<SubscriptionSummary[], Action>(
        dispatch,
        setSubscriptionSummaryAction,
    );
    const setMixSummary = useAction<MixSummary, Action>(dispatch, setMixSummaryAction);

    const actions = useMemo(
        () => ({
            setSubscriptionSummary,
            setMixSummary,
        }),
        [setSubscriptionSummary, setMixSummary],
    );

    return actions;
}

function useSummaryState(): SubscriptionSummaryState {
    const [state, dispatch] = useReducer(reducer, defaultState);
    const actions = useActions(dispatch);

    const summaryState = useMemo(
        () => ({
            ...state,
            actions,
        }),
        [state, actions],
    );

    return summaryState;
}

export default useSummaryState;

export interface SubscriptionSummaryActions {
    setSubscriptionSummary: (param: SubscriptionSummary[]) => void;
    setMixSummary: (param: MixSummary) => void;
}

export type SubscriptionSummaryState = {
    actions: SubscriptionSummaryActions;
} & SummaryState;
